
import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { StaticImageBackground } from './StaticImageBackground';

interface AuthErrorStateProps {
  error: string;
  onRetry: () => void;
}

export const AuthErrorState: React.FC<AuthErrorStateProps> = ({ error, onRetry }) => {
  return (
    <div className="relative w-full min-h-screen flex items-center justify-center overflow-hidden bg-black">
      <StaticImageBackground />
      
      <div className="relative z-10 text-center max-w-md mx-auto p-6">
        <div className="mb-6">
          <AlertCircle className="h-16 w-16 text-red-500 mx-auto mb-4" />
          <h2 className="text-xl font-semibold text-white mb-2">Erro de Autenticação</h2>
          <p className="text-gray-400 mb-6">{error}</p>
        </div>
        
        <Button 
          onClick={onRetry}
          className="w-full luxury-button mb-3"
        >
          <RefreshCw className="h-4 w-4 mr-2" />
          Tentar Novamente
        </Button>
        
        <Button 
          variant="ghost" 
          onClick={() => window.location.reload()}
          className="w-full text-gray-400 hover:text-white"
        >
          Recarregar Página
        </Button>
      </div>
    </div>
  );
};

export default AuthErrorState;
